import React from "react";
import "./loading.scss";

export default function Loading() {
  return (
    <div className="centerContent">
      <div className="kd-circle">
        <div className="kd-circle1 kd-child"></div>
        <div className="kd-circle2 kd-child"></div>
        <div className="kd-circle3 kd-child"></div>
        <div className="kd-circle4 kd-child"></div>
        <div className="kd-circle5 kd-child"></div>
        <div className="kd-circle6 kd-child"></div>
        <div className="kd-circle7 kd-child"></div>
        <div className="kd-circle8 kd-child"></div>
        <div className="kd-circle9 kd-child"></div>
        <div className="kd-circle10 kd-child"></div>
        <div className="kd-circle11 kd-child"></div>
        <div className="kd-circle12 kd-child"></div>
      </div>
    </div>
  );
}
